import axios from "axios";
import { useEffect, useState } from "react";
import { appConstants } from "utils/appConstants";

export const catalogueAccountOptions = [
  ["200 - Sales", "200 - Sales"],
  ["210 - Service Income", "210 - Service Income"],
  ["240 - Rental Income", "240 - Rental Income"],
  ["250 - Dividends Received", "250 - Dividends Received"],
  ["260 - Other Revenue", "260 - Other Revenue"],
  ["265 - Government Grants", "265 - Government Grants"],
  ["270 - Interest Income", "270 - Interest Income"],
  [
    "281 - Capital Gain/(Loss) on Disposal of Other Income",
    "281 - Capital Gain/(Loss) on Disposal of Other Income",
  ],
  [
    "282 - Gain/(Loss) on Sale of Other Income",
    "282 - Gain/(Loss) on Sale of Other Income",
  ],
  ["284 - Employee Contribution", "284 - Employee Contribution"],
  [
    "288 - Partnership Distributions Received",
    "288 - Partnership Distributions Received",
  ],
  ["352 - Freight & Delivery", "352 - Freight & Delivery"],
  ["380 - Closing Stock", "380 - Closing Stock"],
  ["401 - Audit Fees", "401 - Audit Fees"],
  ["404 - Bad Debts Written Off", "404 - Bad Debts Written Off"],
  ["408 - Borrowing Costs Amortised", "408 - Borrowing Costs Amortised"],
  ["411 - Computer Expenses", "411 - Computer Expenses"],
  ["420 - Entertainment", "420 - Entertainment"],
  ["454 - Staff Amenities", "454 - Staff Amenities"],
  ["485 - Subscriptions & Memberships", "485 - Subscriptions & Memberships"],
  ["493 - Travel - National", "493 - Travel - National"],
  ["494 - Travel - International", "494 - Travel - International"],
].map(([value, label]) => ({ value, label }));

export const sortCatalogueAccounts = (accounts = []) =>
  [...accounts].sort(
    (left, right) =>
      Number(left?.categoryCode || 0) - Number(right?.categoryCode || 0)
  );

export const mapCatalogueAccountOptions = (accounts = []) =>
  sortCatalogueAccounts(accounts).map((account) => {
    const label = `${account.categoryCode} - ${account.categoryName}`;
    return {
      label,
      value: account.categoryCodeName || label,
    };
  });

export const useCatalogueAccountOptions = (businessUserID) => {
  const [accountOptions, setAccountOptions] = useState(catalogueAccountOptions);

  useEffect(() => {
    if (!businessUserID) return undefined;

    let isActive = true;
    axios
      .post(appConstants.baseURL + "items/fetchCategoriesData", {
        businessUserID,
      })
      .then((response) => {
        const options = mapCatalogueAccountOptions(
          response.data?.fetchCategories
        );
        if (isActive && options.length) setAccountOptions(options);
      })
      .catch(() => {
        // Keep the standard account list available if live categories fail.
      });

    return () => {
      isActive = false;
    };
  }, [businessUserID]);

  return accountOptions;
};
